<!-- Modern header with glass effect -->
<header class="sticky-top glass-effect animate-fade-in">
  <div class="px-3 sm:px-4 py-3">
    <div class="flex justify-content-between align-items-center">
      <!-- Left side navigation -->
      <div class="flex align-items-center gap-2">
        <p-button
          (onClick)="onBackClick()"
          icon="pi pi-angle-left"
          class="p-button-text p-button-rounded btn-modern touch-target"
          [style]="{ color: 'var(--primary-color)' }"
          pTooltip="Go Back"
          tooltipPosition="bottom"
        ></p-button>

        <p-button
          (onClick)="onHomeClick()"
          icon="pi pi-home"
          class="p-button-text p-button-rounded btn-modern touch-target"
          [style]="{ color: 'var(--primary-color)' }"
          pTooltip="Home"
          tooltipPosition="bottom"
        ></p-button>
      </div>

      <!-- App title/logo -->
      <div class="text-center animate-scale-in">
        <img
          alt="OAK Events Logo"
          style="height: 40px; width: auto; filter: brightness(0) invert(1)"
          src="assets/logo-oak-events-com.png"
        />
      </div>

      <!-- Right side actions -->
      <div>
        <p-button
          (onClick)="onLogout()"
          icon="pi pi-sign-out"
          [label]="isMobile ? '' : 'Logout'"
          class="p-button-text p-button-rounded btn-modern touch-target"
          [style]="{ color: 'var(--primary-color)' }"
          pTooltip="Logout"
          [tooltipPosition]="isMobile ? 'left' : 'bottom'"
        ></p-button>
      </div>
    </div>
  </div>
</header>

<!-- Main content area with animations -->
<main class="animate-slide-up" style="min-height: calc(100dvh - 70px)">
  <div class="p-mobile-friendly" style="padding-bottom: 100px">
    <router-outlet></router-outlet>
  </div>
</main>
